import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { useCreateAnimal } from '../contexts/animals';
import { validateAnimal } from '../utils/validate';
import { buildAnimalPayload } from '../utils/payload';
import AnimalFields from './fields';

import '../../../common/styles/catalog.css';

const EMPTY = {
    baptized: true, name: '', number: '', register: '',
    race_id: '', sex: '', birth: '', appearance: '', description: '',
};

export default function CreateAnimalForm() {
    const navigate = useNavigate();
    const { mutateAsync, isPending } = useCreateAnimal();

    const [form, setForm] = useState(EMPTY);
    const [localErrors, setLocalErrors] = useState({});
    const [serverFields, setServerFields] = useState({});

    const setField = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        if (localErrors[field] || serverFields[field]) {
            setLocalErrors(prev => ({ ...prev, [field]: undefined }));
            setServerFields(prev => ({ ...prev, [field]: undefined }));
        }
    };
    const fieldError = (field) => localErrors[field] || serverFields[field];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateAnimal(form);
        if (Object.keys(errors).length) { setLocalErrors(errors); toast.error('Revisá los campos marcados'); return; }
        setLocalErrors({});
        setServerFields({});

        try {
            const created = await mutateAsync(buildAnimalPayload(form));
            toast.success('Animal creado');
            navigate(`/admin/animals/${created.id}`);
        } catch (err) {
            if (err?.status === 409) { setServerFields({ register: 'Ya existe un animal con ese registro.' }); toast.error('Registro duplicado'); }
            else if (err?.fields) { setServerFields(err.fields); toast.error('Revisá los campos marcados'); }
            else toast.error(err?.message || 'No se pudo crear el animal');
        }
    };

    const baptized = form.baptized !== false;
    const canSubmit = !isPending && (!baptized || (form.name.trim() && form.number.trim())) && !!form.race_id && !!form.sex;

    return (
        <form className="cat-form" onSubmit={handleSubmit}>
            <header className="cat-form__header">
                <Link to="/admin/animals" className="cat-form__back">Animales</Link>
                <h1 className="cat-form__title">Nuevo animal</h1>
            </header>

            <AnimalFields form={form} setField={setField} fieldError={fieldError} disabled={isPending} />

            <footer className="cat-form__footer">
                <Link to="/admin/animals" className="cat-form__cancel">Cancelar</Link>
                <button type="submit" className="cat-form__submit" disabled={!canSubmit}>
                    {isPending ? 'Creando…' : 'Crear animal'}
                </button>
            </footer>
        </form>
    );
}
